var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGanda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 26,
    viewBox: "0 0 156 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2141 0.770601L21.3135 22.026H27.8936L28.9653 18.8524H36.7606L37.794 22.026H44.6644L36.7925 0.770601H29.2141ZM30.6717 13.7267L31.5967 11.0219C32.0592 9.70462 32.4515 8.38733 32.8757 7.1083H32.9491C33.3414 8.38733 33.7688 9.70462 34.193 11.0219L35.0861 13.7267H30.6685H30.6717Z",
    fill: "url(#paint0_linear_48_207)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0708 0.770601L90.1702 22.026H96.7504L97.822 18.8524H105.617L106.651 22.026H113.521L105.649 0.770601H98.0708ZM99.5285 13.7267L100.453 11.0219C100.916 9.70462 101.308 8.38733 101.732 7.1083H101.806C102.198 8.38733 102.626 9.70462 103.05 11.0219L103.943 13.7267H99.5285Z",
    fill: "url(#paint1_linear_48_207)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.128 0.770601H140.55L132.649 22.026H139.229L140.301 18.8524H148.096L149.13 22.026H156L148.128 0.770601ZM142.007 13.7267L142.932 11.0219C143.395 9.70462 143.787 8.38733 144.211 7.1083H144.285C144.677 8.38733 145.104 9.70462 145.529 11.0219L146.422 13.7267H142.007Z",
    fill: "url(#paint2_linear_48_207)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5343 0.100869C55.2602 0.129576 53.2827 5.5104 52.8744 5.91867C51.7677 6.96485 53.7165 1.41179 53.9206 0.799388C53.9493 0.741976 47.7169 0.770682 46.9897 0.770682C45.245 7.86751 45.7649 15.3343 46.9897 22.0899H52.5842C52.7883 19.1523 53.8058 3.8263 57.3813 5.04791C61.0749 6.35564 56.5967 20.4632 55.0561 22.0899H64.9757C66.0219 17.1747 66.4589 12.2596 66.0506 7.34441C65.7285 3.70829 63.6329 0.0721631 59.5343 0.100869Z",
    fill: "url(#paint3_linear_48_207)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.034 0.770601C122.704 1.61584 123.517 3.0384 124.535 5.19136C127.297 10.9518 126.659 13.3057 125.262 13.9755C123.75 14.7027 122.034 12.5784 121.017 8.44793C120.261 5.3349 119.881 2.28246 120.175 0.770601H113.891C112.146 7.31563 111.186 18.8619 126.978 16.9131C129.131 16.709 128.78 18.2208 127.24 18.3675C115.084 19.5604 115.575 13.5991 115.228 16.3039C114.851 19.2702 115.403 22.2078 116.392 24.6223C116.507 24.9126 129.9 27.7194 131.893 15.3725C132.767 9.9566 132.416 4.9649 130.904 0.770601H122.034Z",
    fill: "url(#paint4_linear_48_207)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4612 0.100795C73.3038 -0.128855 68.5226 2.21549 68.5226 2.21549L69.4188 8.83068C69.4188 8.83068 70.0855 8.45431 71.1604 7.99501C71.4379 15.9977 69.4188 22.0292 69.4188 22.0292H74.9209C74.9209 22.0292 74.9017 21.5731 74.889 20.8012C75.9862 21.8538 77.8617 22.7692 80.3751 22.7692C86.6011 22.7692 90.0778 17.8476 90.7157 12.5402C91.3759 7.04771 88.8625 0.36872 80.4612 0.100795ZM79.8137 18.7918C76.4742 18.7918 75.6066 14.8239 76.0532 11.3983C76.3849 8.84982 76.9271 6.99029 77.0994 6.43531C77.6894 6.38746 78.2859 6.3779 78.8792 6.41617C81.2044 6.56927 82.7864 7.76855 83.756 9.24533C85.5932 12.0394 85.4848 18.7918 79.8105 18.7918H79.8137Z",
    fill: "url(#paint5_linear_48_207)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8309 6.46094C15.4192 6.46094 16.931 8.99666 16.931 8.99666L21.1126 3.21714C21.1126 3.21714 17.3616 -0.457265 10.2584 0.174273C2.73419 0.840896 0.00390625 5.61251 0.00390625 11.1177C0.00390625 16.623 3.54115 22.7374 9.17077 22.7374C11.3652 22.7374 12.826 21.924 13.7223 21.1075L13.8084 22.0006H18.3249C18.3249 22.0006 18.529 17.5256 20.261 12.3202L12.9983 13.7364L13.2694 16.4858C12.9281 17.0982 12.2806 17.5065 11.0526 17.5065C8.37337 17.5065 6.69884 15.1143 6.44049 12.9326C6.03222 9.45915 6.96996 6.46094 11.8309 6.46094Z",
    fill: "url(#paint6_linear_48_207)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_207",
    x1: 1.35653,
    y1: -2.69057,
    x2: 109.362,
    y2: -69.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F04E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48_207",
    x1: 1.35653,
    y1: -2.69057,
    x2: 109.362,
    y2: -69.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F04E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_48_207",
    x1: 1.35653,
    y1: -2.69057,
    x2: 109.362,
    y2: -69.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F04E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_48_207",
    x1: 1.35653,
    y1: -2.69057,
    x2: 109.362,
    y2: -69.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F04E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_48_207",
    x1: 1.35653,
    y1: -2.69057,
    x2: 109.362,
    y2: -69.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F04E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_48_207",
    x1: 1.35653,
    y1: -2.69057,
    x2: 109.362,
    y2: -69.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F04E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_48_207",
    x1: 1.35653,
    y1: -2.69057,
    x2: 109.362,
    y2: -69.1315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F04E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99FC9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanda);
export default __webpack_public_path__ + "static/media/ganda.d9eaba7ac7738b2104d02abd57b223e4.svg";
export { ForwardRef as ReactComponent };